import { FC } from "react";
import { capitalize, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { budgetDetailsIsExpiredSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsIsExpiredSelector";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { budgetDetailsStartDateSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsStartDateSelector";
import { budgetDetailsEndDateSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsEndDateSelector";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const BudgetDetailsPeriod: FC = () => {
  const isExpired = useAppSelector(budgetDetailsIsExpiredSelector);
  const period = useAppSelector(budgetDetailsPeriodSelector);
  const startDate = useAppSelector(budgetDetailsStartDateSelector);
  const endDate = useAppSelector(budgetDetailsEndDateSelector);

  if (period !== "custom") {
    return capitalize(period ?? "");
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="inherit">
        {formatDate(startDate ?? "", { type: "dateWithComma" })} -{" "}
        {formatDate(endDate ?? "", { type: "dateWithComma" })}
      </Typography>

      {isExpired && (
        <Stack
          height={18}
          px={1}
          alignItems="center"
          border={1}
          borderRadius={1}
          borderColor="#ED6C0280"
        >
          <Typography fontSize={10} color="warning.main">
            Expired Budget
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
